<div class="switch-button-wrapper flex-center-center" [ngClass]="{'not-allowed': disabled}">
  <div *ngFor="let option of options; let optionIndex = index" id="{{optionIndex}}-first"
    class="switch-btn flex-center-center" [class]="paddingClass"
    [ngClass]="{'pointer': !disabled, 'not-allowed': disabled, 'active': option[valueField] === (value && value[valueField])}"
    (click)="handleChange(option)">

    <span class="selected-circle p-1 mr-1"
      [hidden]="!showselectedCircle || !option[valueField] === (value && value[valueField])"
      [ngStyle]="{'background-color': option.color? option.color: '#ffffff'}"></span>

    <span class="switch-btn-label">
      <i class="{{option.icon}} font-{{fontSize}} pr-2" [hidden]="!showIcons"></i>
      <span class="font-{{fontSize}} font-green">{{option[field]}}</span>
    </span>
  </div>
</div>
